import { ProductProps } from '@components/tickets/StoresSaleProductList'
import { Theme } from '@lib/theming'
import { Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Maybe, StoresTicketInfoPanelFragment } from '@ts/operations'
import React, { ReactElement } from 'react'

import { DynamicFormstackFormProps } from '../forms/DynamicFormstackForm'
import StoresInfoPanel from '../tickets/StoresInfoPanel'
import Panel from './Panel'

export type StoresTicketInfoGridProps = {
  applicationForm?: Maybe<ReactElement<DynamicFormstackFormProps>>
  country: string
  currencySymbol: string
  product?: ProductProps
  releasePhaseId?: string
  ticketInfoPanel: StoresTicketInfoPanelFragment
}

const useStyles = makeStyles<Theme>(theme => ({
  infoPanel: {
    [theme.breakpoints.up('md')]: {
      order: -1,
    },
  },
}))

const StoresTicketInfoGrid = ({
  applicationForm,
  country,
  currencySymbol,
  ticketInfoPanel: { displayPriceIncludingTax, showBenefits, heading },
  product,
}: StoresTicketInfoGridProps) => {
  const classes = useStyles()

  return (
    <>
      <Grid item className={classes.infoPanel} md={4} xs={12}>
        <StoresInfoPanel
          country={country}
          currencySymbol={currencySymbol}
          displayPriceIncludingTax={displayPriceIncludingTax || false}
          heading={heading || undefined}
          product={product}
          showBenefits={showBenefits}
        />
      </Grid>
      {applicationForm && (
        <Grid item md={8} xs={12}>
          <Panel>{applicationForm}</Panel>
        </Grid>
      )}
    </>
  )
}

export default StoresTicketInfoGrid
